<template>
	<v-list-item-subtitle v-bind="$attrs" v-on="$listeners">
		<slot></slot>
	</v-list-item-subtitle>
</template>

<script>
export default {
	name: 'KListItemSubtitle'
};
</script>